var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 114"
  }, /*#__PURE__*/React.createElement("path", {
    id: "->",
    d: "M14.518 20.1261C14.0457 20.607 13.2714 20.6092 12.7964 20.1309C12.3295 19.6609 12.3274 18.9029 12.7916 18.4303L17.8761 13.254H4.25402C3.56144 13.254 3 12.6926 3 12C3 11.3074 3.56144 10.746 4.25402 10.746H17.8761L12.7926 5.579C12.3276 5.10632 12.3283 4.3478 12.7943 3.87604C13.2701 3.39437 14.0481 3.39546 14.5225 3.87845L21.7937 11.281C22.1858 11.6801 22.1858 12.3199 21.7937 12.719L14.518 20.1261Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteArrowRight);
export default __webpack_public_path__ + "static/media/white-arrow-right.e7a91fbb589df878ec32e5de56d36b4f.svg";
export { ForwardRef as ReactComponent };